/**
@format
@flow
*/

import type { Viewports } from '@ziynx/flow-types/globals';

type ViewportData = {
  [viewport: Viewports]: string,
  default: string,
}

/**
 * Function to determine measurements used for width, height based on viewports
 */
const getMeasures = (viewportData: ViewportData, viewport: Viewports): string => {
  if (!viewportData[viewport]) return viewportData.default;
  return viewportData[viewport];
};

export default getMeasures;
